import React from 'react'
import { StyledTechLayout } from './styled'
import { TechLayoutProps } from './types'

export const TechLayout: React.FC<TechLayoutProps> = (props: TechLayoutProps) => {
  return <StyledTechLayout {...props} />
}
